import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { RemoveToWishlistSuccess } from '@app/+product/store/actions/product.action';

/**
 * When the user removes an item from his wishlist.
 */
const events = getEvents((action: RemoveToWishlistSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productRemoveFromWishlist',
      addToWishlistType: 'product_page',
      product_brand: action.payload.brand.name,
      product_category: action.payload.category.name,
      product_univers: action.payload.universe.name
    }
  }
]);

export default events;
